import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Privacy Policy</h1>

      <h2>Introduction</h2>
      <p>
        At NovaHomes, we are committed to protecting your privacy and ensuring the security of your
        personal information. This Privacy Policy ("Policy") explains how we collect, use, disclose,
        and safeguard your information when you use our website, mobile application, or any related
        services (collectively referred to as the "Platform"). By using the Platform, you consent to
        the practices described in this Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect information that you provide directly, as well as information automatically collected through your use of the Platform.</p>

      <h3>1.1 Information You Provide</h3>
      <p>
        When you create an account, submit inquiries, or interact with the Platform, you may provide
        us with:
      </p>
      <ul>
        <li>Personal Information: Name, email address, phone number, and other contact details.</li>
        <li>Account Information: Username, password, and preferences.</li>
        <li>Payment Information: Credit card details or other payment methods, if applicable.</li>
        <li>Property Information: Details about properties you list or inquire about.</li>
      </ul>

      <h3>1.2 Automatically Collected Information</h3>
      <p>
        We may automatically collect information about your device and usage patterns, including:
      </p>
      <ul>
        <li>Device Information: IP address, browser type, operating system, and device identifiers.</li>
        <li>Usage Data: Pages visited, time spent on the Platform, and interactions with features.</li>
        <li>Location Data: Approximate location based on your IP address or GPS, if enabled.</li>
      </ul>

      <h3>1.3 Cookies and Tracking Technologies</h3>
      <p>
        We use cookies, web beacons, and similar technologies to enhance your experience and analyze
        Platform usage. Cookies are small files stored on your device that help us remember your
        preferences and improve functionality. You can manage cookie settings through your browser,
        but disabling cookies may limit certain features of the Platform.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect for various purposes, including:</p>
      <ul>
        <li>Providing Services: To deliver and personalize the Platform, process transactions, and respond to inquiries.</li>
        <li>Improving Functionality: To analyze usage patterns, troubleshoot issues, and enhance the user experience.</li>
        <li>Marketing and Communication: To send promotional offers, newsletters, and updates, subject to your consent where required by law.</li>
        <li>Legal Compliance: To comply with legal obligations, enforce our policies, and protect our rights and interests.</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>We may share your information with third parties under the following circumstances:</p>
      <ul>
        <li>Service Providers: Trusted partners who assist us in operating the Platform, conducting business, or servicing users.</li>
        <li>Business Transfers: In connection with mergers, acquisitions, or asset sales, where your information may be transferred as part of the transaction.</li>
        <li>Legal Requirements: When required by law or to protect our rights, property, or safety.</li>
      </ul>
      <p>We do not sell or rent your personal information to third parties for their marketing purposes without your consent.</p>

      <h2>4. Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your information from
        unauthorized access, alteration, disclosure, or destruction. However, no method of
        transmission over the internet or electronic storage is completely secure. While we strive
        to protect your data, we cannot guarantee absolute security.
      </p>

      <h2>5. Retention of Information</h2>
      <p>
        We retain your information for as long as necessary to fulfill the purposes outlined in this
        Policy, unless a longer retention period is required or permitted by law. You may request
        the deletion of your account and associated data, subject to applicable legal obligations.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have certain rights regarding your personal
        information, including:
      </p>
      <ul>
        <li>Access: The right to request a copy of the information we hold about you.</li>
        <li>Correction: The right to correct inaccuracies in your information.</li>
        <li>Deletion: The right to request the deletion of your information.</li>
        <li>Opt-Out: The right to opt out of receiving marketing communications.</li>
      </ul>

      <h2>7. Children's Privacy</h2>
      <p>
        The Platform is not intended for children under the age of 13. We do not knowingly collect
        personal information from children under 13. If we become aware that we have inadvertently
        collected such information, we will take steps to delete it promptly.
      </p>

      <h2>8. International Users</h2>
      <p>
        If you access the Platform from outside [Your Country], you consent to the transfer, storage,
        and processing of your information in [Your Country] or other jurisdictions where NovaHomes
        operates. These regions may have different data protection laws than your own.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We reserve the right to update or modify this Policy at any time. If we make material changes,
        we will notify you by posting a notice on the Platform or sending an email to the address
        associated with your account. Your continued use of the Platform after such changes constitutes
        your acceptance of the revised Policy.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Policy, please contact us.
      </p>
    </div>
  );
};

export default PrivacyPolicy;